import { Injectable } from '@angular/core';
import{ environment }from '../../../../environments/environment';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { Observable, Subject,BehaviorSubject} from 'rxjs';
import {User,Role} from './../../../models/admin'
@Injectable({
  providedIn: 'root'
})
export class RoleService {
  API_URL=environment.API_URL;
  private data = new BehaviorSubject<any>([]);
  constructor(private http:HttpClient) { }
  setid(id:number) {
    this.data.next({ 'Id': id });
  }
  getId() {
    return this.data.asObservable();
  }
  addRole(data:Role){
    return this.http.post(this.API_URL+'/admin/addRole',data);
  }
  selectData(id:number){
    return this.http.get(this.API_URL+'/admin/role/'+id);
  }
  updateRole(data:Role){
    return this.http.put(this.API_URL+'/admin/role/'+data.id,data);
  }
  unsubscribeData() {
    this.data.next('');
  }

  getMe(){
    return this.http.post(this.API_URL+'/admin/me',{});
  }

  
}
